import { render, staticRenderFns } from "./fileHistory.vue?vue&type=template&id=2edb98c2&scoped=true&"
import script from "./fileHistory.vue?vue&type=script&lang=js&"
export * from "./fileHistory.vue?vue&type=script&lang=js&"
import style0 from "./fileHistory.vue?vue&type=style&index=0&id=2edb98c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edb98c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2edb98c2')) {
      api.createRecord('2edb98c2', component.options)
    } else {
      api.reload('2edb98c2', component.options)
    }
    module.hot.accept("./fileHistory.vue?vue&type=template&id=2edb98c2&scoped=true&", function () {
      api.rerender('2edb98c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/components/BillPayment/siRui/fileHistory.vue"
export default component.exports